var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import cl from "clsx";
import React, { forwardRef } from "react";
import { DefaultIllustration } from "./Illustration";
/**
 * A component for guiding users on the website
 *
 * @see [📝 Documentation](https://aksel.nav.no/komponenter/core/guidepanel)
 * @see 🏷️ {@link GuidePanelProps}
 *
 * @example
 * ```jsx
 * <GuidePanel>
 *   Saksbehandlingstiden varierer fra kommune til kommune. Hvis det går mer
 *   enn X måneder siden du søkte, skal du få brev om at saksbehandlingstiden
 *   er forlenget.
 * </GuidePanel>
 * ```
 */
export const GuidePanel = forwardRef((_a, ref) => {
    var { children, className, illustration, poster } = _a, rest = __rest(_a, ["children", "className", "illustration", "poster"]);
    return (React.createElement("div", Object.assign({}, rest, { ref: ref, className: cl("navds-guide-panel", className, {
            "navds-guide-panel--poster": poster === true,
            "navds-guide-panel--not-poster": poster === false,
            "navds-guide-panel--responsive-poster": poster === undefined,
        }) }),
        React.createElement("div", { className: "navds-guide" }, illustration !== null && illustration !== void 0 ? illustration : React.createElement(DefaultIllustration, null)),
        React.createElement("div", { className: "navds-guide-panel__content" }, children)));
});
export default GuidePanel;
//# sourceMappingURL=GuidePanel.js.map